import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { fetchData, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr';

interface AddTourPackageProps {
  tourpackageId: string; // Assuming tourpackageId is of type string, adjust as needed
}
const AddTourPackageHeader: React.FC<AddTourPackageProps> = ({ tourpackageId }) => {
  const t = Tr()
  const location = useLocation();
  const editTourpackageId = (location.state as any)?.tourpackageId || '';

  const [tourPackageDetails, setTourPackageDetails] = useState([]);
  // hotel Details api call
  const tourpackageDetailsApiCall = async () => {

    if (tourpackageId != "") {

      var param: any = {
        tourpackageId: tourpackageId,
      }
    } else if (editTourpackageId != "") {
      var param: any = {
        tourpackageId: editTourpackageId,
      }
    }
    var response: any = await fetchData("public/tourpackageDetails", param)

    if (response.status == "200") {
      setTourPackageDetails(response.data);
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editTourpackageId != "") {
      tourpackageDetailsApiCall()
    }
  }, [])

  const tabRefs = useRef([]) as any;
  const indexTab = sessionStorage.getItem('indexTab') || 0;

  useEffect(() => {
    const scrollToTab = () => {
      // Check if the tabRefs array is populated and if the indexTab element exists
      if (tabRefs.current.length > 0 && tabRefs.current[indexTab]) {
        // Delay scrollIntoView to ensure all rendering is complete
        setTimeout(() => {
          tabRefs?.current[indexTab]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',  // Scroll vertically to nearest edge
            inline: 'center'   // Scroll horizontally to center
          });
        }, 700);
      }
    };
    scrollToTab();
    // Add event listener for window load event to handle case of page refresh
    window.addEventListener('load', scrollToTab);
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('load', scrollToTab);
    };
  }, [location, indexTab]);
  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {
                  tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['basicInfo'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagebasicinfo/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addtourpackagebasicinfo/'
                      state={{ tourpackageId: editTourpackageId }}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagebasicinfo/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['location'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagelocation/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addtourpackagelocation/'
                      state={{ tourpackageId: editTourpackageId }}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagelocation/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['toursDetail'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['toursDetail'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewtours/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['toursDetail'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewtours/'
                      state={{ tourpackageId: editTourpackageId }}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Tours')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['toursDetail'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewtours/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['toursDetail'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Tours')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['photos'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagephotos/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addtourpackagephotos/'
                      state={{ tourpackageId: editTourpackageId }}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Photos')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagephotos/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Photos')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['policies'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagepolicies/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addtourpackagepolicies/'
                      state={{ tourpackageId: editTourpackageId }}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Policies')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagepolicies/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Policies')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['financeAndLegal'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagefinance/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addtourpackagefinance/'
                      state={{ tourpackageId: editTourpackageId }}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Finance & Legal')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addtourpackagefinance/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Finance & Legal')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['contract'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewtourcontract/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewtourcontract/'
                      state={{ tourpackageId: editTourpackageId }}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Contract Agreement')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewtourcontract/' ? `${tourPackageDetails && tourPackageDetails.length > 0 && tourPackageDetails[0]['completedSteps'] && tourPackageDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Contract Agreement')}
                    </button>
                  )
                }
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export { AddTourPackageHeader }
